import React, { useState, useRef, useEffect, useContext, useCallback } from 'react'
// import {  useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { actlistData, actmore, setisfirsttime } from "../../actions/index";
import Navigationtitle from "../include/Navigationtitle";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import DataService from "../../services/tutorial.service";
import { getDatabase, ref, remove, push, onValue, set, off, update } from "firebase/database";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faL, faShareNodes } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from "react-confirm-alert";
import { gif1, gif2, gif3, gif4 } from "../../constants/Images";
import { MdOutlineSettingsBackupRestore } from "react-icons/md";
import { IoColorPaletteOutline } from "react-icons/io5";
import { ImFontSize } from "react-icons/im";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
import { CiImport } from "react-icons/ci";
import { IoEyeOutline } from "react-icons/io5";
import { BiHide } from "react-icons/bi";
import { teamdefaultLogo } from "../../constants/Images";

import { TbListDetails } from "react-icons/tb";
import {

    theme1,
    theme2,
    theme3,
    theme4,
    theme5,
    theme6,
    theme7,
    theme8,
    theme9,
    theme10,
    theme11,
    theme12,
    theme13,
    theme14,
    theme15,
    theme16,
    theme17,
    theme18,
    theme19,
    theme20,

} from "../../constants/Images";
import { useSelector, useDispatch } from "react-redux";
import { BsLayoutWtf } from "react-icons/bs";
import { PiSelectionBackgroundFill } from "react-icons/pi";


export default function AuctionCustomization(match) {
    const dispatch = useDispatch();

    const loginuser = useSelector((state) => state.setUserlog);

    const aucmoredetail = useSelector((state) => state.actmoredata);
    const [aucdetail, setaucdetail] = useState(aucmoredetail);
    const [aucback, setaucback] = useState("");
    const [selectedOption, setSelectedOption] = useState('0');

    const [aucbackbox, setaucbackbox] = useState("");
    const [aucstampbox, setaucstampbox] = useState("");
    const [aucustampbox, setaucustampbox] = useState("");
    const [aucsoldstamp, setaucsoldstamp] = useState("");
    const [aucunsoldstamp, setaucunsoldstamp] = useState("");
    const [aucsponsorbox, setaucsponsorbox] = useState("");
    const [aucbannerbox, setaucbannerbox] = useState("");
    const [aucsponsor, setaucsponsor] = useState("");
    const [aucbanner, setaucbanner] = useState("");
    const [isimgpop, setisimgpop] = useState(false);
    const [imgpopdata, setimgpopdata] = useState([]);
    const [imgpoptype, setimgpoptype] = useState("");
    const [isbgpop, setisbgpop] = useState(false)
    const [bgdata, setbgdata] = useState([])
    const [isfullbg, setisfullbg] = useState(false)
    const [selectedbgfl, setselectedbgfl] = useState("")
    const [bgfulldata, setbgfulldata] = useState('')
    const [customtype, setcustomtype] = useState('theme')
    const [mythemes, setmythemes] = useState([{ img: theme1, no: 1 }, { img: theme2, no: 2 }, { img: theme6, no: 6 }, { img: theme8, no: 8 }, { img: theme10, no: 10 }
        // ,{img:theme12,no:12}
        , { img: theme18, no: 18 }
    ])
    const [isActive, setActive] = useState(false);
    const [cid, setCid] = useState(loginuser["cid"]);
    const aid = localStorage.getItem("auction_id");
    const updtoken = useSelector((state) => state.updtoken);
    const [activeDrawer, setActiveDrawer] = useState(null);
    //////////////////////////////////// Themes params //////////////////////////////////
    const [color, setcolor] = useState('')
    const [color2, setcolor2] = useState('')
    const [color3, setcolor3] = useState('')
    const [color4, setcolor4] = useState('')
    const [color5, setcolor5] = useState('')
    const [color6, setcolor6] = useState('')
    const [color7, setcolor7] = useState('')
    const [color8, setcolor8] = useState('')
    const [color9, setcolor9] = useState('')
    const [color10, setcolor10] = useState('')
    const [color11, setcolor11] = useState('')
    const [color12, setcolor12] = useState('')
    const [color13, setcolor13] = useState('')
    const [color14, setcolor14] = useState('')
    const [color15, setcolor15] = useState('')
    const [color16, setcolor16] = useState('')
    const [color17, setcolor17] = useState('')
    const [color18, setcolor18] = useState('')
    const [color19, setcolor19] = useState('')
    const [color20, setcolor20] = useState('')
    const [isplbg, setisplbg] = useState('')
    const [teamfont, setteamfont] = useState('')
    const [maindetailfont, setmaindetailfont] = useState('')
    const [detailfont, setdetailfont] = useState('')
    const [bidfont, setbidfont] = useState('')
    const [plnamefont, setplnamefont] = useState('')
    const [pldetailfont, setpldetailfont] = useState('')
    const [themebg, setthemebg] = useState(bgdata?.path + '27016241009155915341.png')
    const [theme, settheme] = useState('')
    const [showteam, setshowteam] = useState(true)
    const [showmax, setshowmax] = useState(true)
    const [showauctionhead, setshowauctionhead] = useState(true)
    const [showextradesign, setshowextradesign] = useState(true)

    //////////////////////////////////////////////////////////////////////////////
    const history = useHistory({ forceRefresh: true });


    const colorRef = useRef(null);
    const fontRef = useRef(null);
    const displayref = useRef(null);

    const fileInputRefs = useRef(Array.from({ length: 8 }, () => React.createRef()));

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const toggleDrawer = (drawer) => {
        setActiveDrawer(activeDrawer === drawer ? null : drawer);
    };
    const GIFComponent = () => {
        switch (selectedOption) {
            case '0':
                return <img src={gif1} alt="GIF 1" />;
            // case '1':
            //   return <img src={gif2} alt="GIF 2" />;
            case '2':
                return <img src={gif2} alt="GIF 3" />;
            case '3':
                return <img src={gif3} alt="GIF 4" />;
            case '4':
                return <img src={gif4} alt="GIF 4" />;
            default:
                return null;
        }
    };
    useEffect(async () => {

        //  console.log('auc more detail')
        //  console.log(aucdetail)
        //  console.log(aucmoredetail)
        //  console.log(aucmoredetail.detail.auctionname)
        await chooseback()
        if (aucmoredetail.more && aucmoredetail.more.length > 0) {
            if (aucmoredetail.more[0].bg != "" && aucmoredetail.more[0].bg != null) {
                // //  console.log('auc more data bg image...!!')
                setaucbackbox(aucmoredetail.fpath + aucmoredetail.more[0].bg)
            }

            if (aucmoredetail.more[0].sstamp != "" && aucmoredetail.more[0].sstamp != null) {
                setaucstampbox(aucmoredetail.fpath + aucmoredetail.more[0].sstamp)
            }
            if (aucmoredetail.more[0].fireworks != "" && aucmoredetail.more[0].fireworks != null) {
                setSelectedOption(aucmoredetail.more[0].fireworks)
            }
            if (aucmoredetail.more[0].usstamp != "" && aucmoredetail.more[0].usstamp != null) {
                setaucustampbox(aucmoredetail.fpath + aucmoredetail.more[0].usstamp)
            }
            if (aucmoredetail.more[0].bg) {
                //  console.log('here is the background')
                setthemebg(bgdata?.path + aucmoredetail.more[0].bg)
            }
            else {
                //  console.log('here is the background 2222')
                //  console.log(bgdata?.path + '27016241009155915341.png')
                // setthemebg(bgdata?.path + '27016241009155915341.png' )
            }

            if (aucmoredetail.more[0].theme && aucmoredetail.more[0].theme != '0') {
                //  console.log('here is the theme')

                settheme(aucmoredetail.more[0].theme)
            }
            else {
                //  console.log('here is the theme 2222')

                settheme(2)
            }
            if (aucmoredetail.custom) {
                //  console.log('setting your theme !!')
                const thData = aucmoredetail.custom;
                //  console.log(thData)
                if (thData.colors) {
                    console.log(thData.colors.pl_name_dt_c)
                    setcolor(thData.colors.title_c)
                    setcolor2(thData.colors.bid_c)
                    setcolor3(thData.colors.pl_name_dt_c)
                    setcolor4(thData.colors.border_c)
                    setcolor5(thData.colors.team_C)
                    setcolor6(thData.colors.pl_head_gc1)
                    setcolor7(thData.colors.pl_head_gc2)
                    setcolor8(thData.colors.pl_border_c)
                    setcolor9(thData.colors.pl_shadow_c)
                    setcolor10(thData.colors.pl_detail_bg_gc1)
                    setcolor11(thData.colors.pl_detail_bg_gc2)
                    setcolor12(thData.colors.pl_dt_shadow_c)
                    setcolor13(thData.colors.extra_dt_c)
                    setcolor14(thData.colors.mp_label_c)
                    setcolor15(thData.colors.mp_val_c)
                    setcolor16(thData.colors.pl_border_gc1)
                    setcolor17(thData.colors.pl_border_gc2)
                    setcolor18(thData.colors.mp_bg_gc1)
                    setcolor19(thData.colors.mp_bg_gc2)

                    setteamfont(thData.fonts.tema_f)
                    setbidfont(thData.fonts.bid_f)
                    setplnamefont(thData.fonts.pl_name_f)
                    setpldetailfont(thData.fonts.pl_detail_f)
                    setdetailfont(thData.fonts.detail_f)
                    setmaindetailfont(thData.fonts.pl_data_f)

                    setshowauctionhead(thData.display.auc_head_show)
                    setshowmax(thData.display.max_pl_show)
                    setshowextradesign(thData.display.extra_design_show)
                    setshowteam(thData.display.team_show)

                }

            }

        }
    }, [aucmoredetail])

    useEffect(() => {
        if (colorRef.current) {
            colorRef.current.style.maxHeight = activeDrawer === 'colors'
                ? `${colorRef.current.scrollHeight}px`
                : '0px';
        }
        if (fontRef.current) {
            fontRef.current.style.maxHeight = activeDrawer === 'fonts'
                ? `${fontRef.current.scrollHeight}px`
                : '0px';
        }
        if (displayref.current) {
            displayref.current.style.maxHeight = activeDrawer === 'display'
                ? `${displayref.current.scrollHeight}px`
                : '0px';
        }
    }, [activeDrawer]);
    function defaultset(forceDefault = false) {
        //  console.log('setting the theme accordingly')
        var themeData = {}

        // First check if we have custom settings from API for this theme
        if (!forceDefault && aucmoredetail.custom?.colors && aucmoredetail.more[0].theme==theme) {
            // Use API values instead of defaults
            themeData = {
                // Colors
                color: aucmoredetail.custom.colors.title_c,
                color2: aucmoredetail.custom.colors.bid_c,
                color3: aucmoredetail.custom.colors.pl_name_dt_c,
                color4: aucmoredetail.custom.colors.border_c,
                color5: aucmoredetail.custom.colors.team_C,
                color6: aucmoredetail.custom.colors.pl_head_gc1,
                color7: aucmoredetail.custom.colors.pl_head_gc2,
                color8: aucmoredetail.custom.colors.pl_border_c,
                color9: aucmoredetail.custom.colors.pl_shadow_c,
                color10: aucmoredetail.custom.colors.pl_detail_bg_gc1,
                color11: aucmoredetail.custom.colors.pl_detail_bg_gc2,
                color12: aucmoredetail.custom.colors.pl_dt_shadow_c,
                color13: aucmoredetail.custom.colors.extra_dt_c,
                color14: aucmoredetail.custom.colors.mp_label_c,
                color15: aucmoredetail.custom.colors.mp_val_c,
                color16: aucmoredetail.custom.colors.pl_border_gc1,
                color17: aucmoredetail.custom.colors.pl_border_gc2,
                color18: aucmoredetail.custom.colors.mp_bg_gc1,
                color19: aucmoredetail.custom.colors.mp_bg_gc2,
                color20: aucmoredetail.custom.colors.sub_title_c,

                // Fonts
                teamfont: aucmoredetail.custom.fonts.tema_f,
                maindetailfont: aucmoredetail.custom.fonts.pl_data_f,
                detailfont: aucmoredetail.custom.fonts.detail_f,
                bidfont: aucmoredetail.custom.fonts.bid_f,
                plnamefont: aucmoredetail.custom.fonts.pl_name_f,
                pldetailfont: aucmoredetail.custom.fonts.pl_detail_f,

                // Display settings
                showteam: aucmoredetail.custom.display.team_show,
                showauctionhead: aucmoredetail.custom.display.auc_head_show,
                showmax: aucmoredetail.custom.display.max_pl_show,
                showextradesign: aucmoredetail.custom.display.extra_design_show,

                // Background settings
                bg: aucmoredetail.more[0].bg,
            }
        } else {
            // Use theme defaults if no custom settings exist
            if (theme == 1) {
                themeData = {
                    color: '#EDE07A',
                    color2: '#ffff00',
                    color3: '#ffffff',
                    color13: '#ffffff',
                    color4: '#E98A3A',
                    color5: '#ffffff',
                    color6: '#e38348',
                    color7: '#db1b2b',
                    color8: '',
                    color9: '',
                    color10: '#CBA543',
                    color11: '',
                    color14: '#CBA543',
                    color15: '#ffffff',
                    teamfont: '22.5',
                    maindetailfont: '20',
                    detailfont: '15',
                    bidfont: '80',
                    bg: '27016241009155927780.jpg',
                    plbg: false
                }
            }
            if (theme == 2) {
                themeData = {
                    color: '#EDE07A',
                    color2: '#ffff00',
                    color3: '#ffffff',
                    color13: '#ffffff',
                    color4: '#E98A3A',
                    color5: '#ffffff',
                    color6: '#e38348',
                    color7: '#db1b2b',
                    color8: '',
                    color9: '',
                    color10: '',
                    color11: '',
                    color14: '#000000',
                    color15: '#ffffff',
                    color15: '#ffffff',
                    color16: '#F1823B',
                    color17: '#EA4633',
                    color18: '#EF7D39',
                    color19: '#E74132',
                    teamfont: '22.5',
                    maindetailfont: '20',
                    detailfont: '15',
                    bidfont: '80',
                    bg: '27016241009155915341.png',
                    plbg: true
                }
            }
            if (theme == 6) {
                themeData = {
                    color: '#230677',
                    color2: '#380d4b',
                    color3: '#ffffff',
                    color13: '#ffffff',
                    color4: '#4a06a0',
                    color5: '#ffffff',
                    color6: '#e38348',
                    color7: '#db1b2b',
                    color8: '',
                    color9: '',
                    color10: '#380d4b',
                    color11: '',
                    color14: '#3d0487',
                    color15: '#663399',
                    color16: '#3d0487',
                    color17: '#b45728',
                    teamfont: '18.5',
                    maindetailfont: '20',
                    detailfont: '15',
                    bidfont: '80',
                    bg: '27016241011125270772.png',
                    plbg: false
                }
            }
            if (theme == 8) {
                themeData = {
                    color: '#ffffff',
                    color2: '#ffffff',
                    color3: '#000000',
                    color4: '#824E2E',
                    color5: '#ffffff',
                    color6: '',
                    color7: '',
                    color8: '#d3ac1d',
                    color9: '#947b1e',
                    color10: '#bc791a',
                    color11: '#d3ac1d',
                    color12: '#947b1e',
                    color13: '#ffffff',
                    color14: '#CBA543',
                    color15: '#ffffff',
                    teamfont: '18.5',
                    maindetailfont: '',
                    detailfont: '17',
                    pldetailfont: '17',
                    plnamefont: '25',
                    bidfont: '80',
                    bg: '27016241009155971071.png',
                    plbg: false
                }
            }
            if (theme == 10) {
                //  console.log('inside 10th theme')
                themeData = {
                    color: '#EDE07A',
                    color2: '#FFFF00',
                    color3: '#ffffff',
                    color4: '#8a2be2',
                    color5: '#FFFF00',
                    color6: '#ffffff',
                    color7: '#ffffff',
                    color8: '#d3ac1d',
                    color9: '#947b1e',
                    color10: '#bc791a',
                    color11: '#d3ac1d',
                    color12: '#947b1e',
                    color13: '#ffffff',
                    color14: '#CBA543',
                    color15: '#ffffff',
                    color16: '#BD48D3',
                    color17: '#224AAA',
                    color18: '#BD48D3',
                    color19: '#224AAA',
                    teamfont: '18.5',
                    maindetailfont: '20',
                    detailfont: '15',
                    pldetailfont: '17',
                    plnamefont: '25',
                    bidfont: '80',
                    bg: '27016241009160087500.png',
                    plbg: true
                }
            }

            if (theme == 12) {
                //  console.log('inside 10th theme')
                // //  console.log()
                themeData = {
                    color: '#EDE07A',
                    color2: '#FFFF00',
                    color3: '#ffffff',
                    color4: '#8a2be2',
                    color5: '#FFFF00',
                    color6: '#ffffff',
                    color7: '#ffffff',
                    color8: '#d3ac1d',
                    color9: '#947b1e',
                    color10: '#bc791a',
                    color11: '#d3ac1d',
                    color12: '#947b1e',
                    color13: '#ffffff',
                    color14: '#CBA543',
                    color15: '#ffffff',
                    color16: '#BD48D3',
                    color17: '#224AAA',
                    color18: '#BD48D3',
                    color19: '#224AAA',
                    teamfont: '18.5',
                    maindetailfont: '20',
                    detailfont: '15',
                    pldetailfont: '17',
                    plnamefont: '25',
                    bidfont: '80',
                    bg: '27016241009160064147.jpg',
                    plbg: false
                }
            }
            if (theme == 18) {
                //  console.log('inside 10th theme')
                themeData = {
                    color: '#EDE07A',
                    color2: '#FFFF00',
                    color3: '#000000',
                    color4: '#8a2be2',
                    color5: '#ffffff',
                    color6: '#ffffff',
                    color7: '#ffffff',
                    color8: '#d3ac1d',
                    color9: '#947b1e',
                    color10: '#cea44e',
                    color11: '#fdf4a7',
                    color12: '#947b1e',
                    color13: '#ffffff',
                    color14: '#000000',
                    color15: '#ffffff',
                    color16: '#ba842a',
                    color17: '#f7e981',
                    color18: '#EF7D39',
                    color19: '#E74132',
                    teamfont: '18.5',
                    maindetailfont: '20',
                    detailfont: '15',
                    pldetailfont: '17',
                    plnamefont: '25',
                    bidfont: '80',
                    bg: '27016241011125270772.png',
                    plbg: false
                }
            }
        }

        // Apply the settings
        setcolor(themeData.color)
        setcolor2(themeData.color2)
        setcolor3(themeData.color3)
        setcolor4(themeData.color4)
        setcolor5(themeData.color5)
        setcolor6(themeData.color6)
        setcolor7(themeData.color7)
        setcolor8(themeData.color8)
        setcolor9(themeData.color9)
        setcolor10(themeData.color10)
        setcolor11(themeData.color11)
        setcolor12(themeData.color12)
        setcolor13(themeData.color13)
        setcolor14(themeData.color14)
        setcolor15(themeData.color15)
        setcolor16(themeData.color16)
        setcolor17(themeData.color17)
        setcolor18(themeData.color18)
        setcolor19(themeData.color19)
        setteamfont(themeData.teamfont)
        setmaindetailfont(themeData.maindetailfont)
        setdetailfont(themeData.detailfont)
        setpldetailfont(themeData.pldetailfont)
        setplnamefont(themeData.plnamefont)
        setbidfont(themeData.bidfont)
        setisplbg(themeData.plbg)
        setthemebg(bgdata?.path + themeData.bg)
    }
    const downloadcustomchanges = () => {
        const themeJSON = {
            color: color,
            color2: color2,
            color3: color3,
            color4: color4,
            color5: color5,
            color6: color6,
            color7: color7,
            color8: color8,
            color9: color9,
            color10: color10,
            color11: color11,
            color12: color12,
            color13: color13,
            color14: color14,
            color15: color15,
            color16: color16,
            color17: color17,
            color18: color18,
            color19: color19,
            teamfont: teamfont,
            plnamefont: plnamefont,
            pldetailfont: pldetailfont,
            showteam: showteam,
            showauctionhead: showauctionhead,
            showmax: showmax,
            showextradesign: showextradesign,
            maindetailfont: maindetailfont,
            detailfont: detailfont,
            bidfont: bidfont,
            bg: themebg,
            theme: theme
        }
        // Convert the object to a JSON string
        const dataStr = JSON.stringify(themeJSON, null, 2); // Pretty format with 2 spaces

        // Create a Blob with the data
        const blob = new Blob([dataStr], { type: "application/json" });

        // Create a link element
        const link = document.createElement("a");

        // Create a download URL from the Blob
        const url = URL.createObjectURL(blob);

        // Set the download link attributes
        link.href = url;
        link.download = "theme.json"; // The name of the file to be saved

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by revoking the object URL after the download
        URL.revokeObjectURL(url);
    }
    const askdefaultset = (id) => {
        confirmAlert({
            message: "Are you want to download changes ?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => { downloadcustomchanges(); defaultset(true) },
                },
                {
                    label: "No",
                    onClick: () => defaultset(true),
                },
            ],
        });
    };
    useEffect(() => {
        chooseback()
        defaultset()

    }, [theme])
    const handleImportClick = () => {
        document.getElementById('fileInputt').click();
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const isFirstMount = localStorage.getItem('isFirstMount');
        //  console.log('isFirstMount')
        //  console.log(isFirstMount)
        // if (!isFirstMount) {
        //   //  console.log('setting false')
        //   localStorage.setItem('isFirstMount', false);
        // } else {
        //   //  console.log('going back....')

        //   localStorage.removeItem('isFirstMount');
        //   history.push('/auction-detail');
        // }
    }, [history]);

    // useEffect(() => {
    //     if (bgdata !== '' && bgdata.length != 0) {
    //         //  console.log('bg data kya h be')
    //         //  console.log(bgdata)

    //         setthemebg(bgdata.path + bgdata.list[0].fl)
    //     }
    // }, [bgdata])

    const handlethemeFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const json = JSON.parse(e.target.result);
                    settheme(json.theme)
                    setcolor(json.color)
                    setcolor2(json.color2)
                    setcolor3(json.color3)
                    setcolor4(json.color4)
                    setcolor5(json.color5)
                    setcolor6(json.color6)
                    setcolor7(json.color7)
                    setcolor8(json.color8)
                    setcolor9(json.color9)
                    setcolor10(json.color10)
                    setcolor11(json.color11)
                    setcolor12(json.color12)
                    setcolor13(json.color13)
                    setcolor14(json.color14)
                    setcolor15(json.color15)
                    setcolor16(json.color16)
                    setcolor17(json.color17)
                    setcolor18(json.color18)
                    setcolor19(json.color19)
                    setteamfont(json.teamfont)
                    setmaindetailfont(json.maindetailfont)
                    setdetailfont(json.detailfont)
                    setplnamefont(json.plnamefont)
                    setpldetailfont(json.pldetailfont)
                    setbidfont(json.bidfont)
                    setthemebg(json.bg)
                    setshowteam(json.showteam)
                    setshowauctionhead(json.showauctionhead)
                    setshowmax(json.showmax)
                    setshowextradesign(json.showextradesign)

                    // setThemeData(json); // Set the JSON data to state
                    //  console.log('Imported JSON:', json); // Debugging
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                }
            };
            reader.readAsText(file); // Read file as text
        }
    };
    const handleFileChange = (e, t) => {
        const file = e.target.files[0];
        if (t == "1") {
            setaucback(file)
        }
        else if (t == "2") {
            setaucsoldstamp(file)
        }
        else if (t == "3") {
            setaucunsoldstamp(file)
        }
        else if (t == "4") {
            setaucsponsor(file)
        }
        else if (t == "5") {
            setaucbanner(file)
        }
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                if (t == "1") {
                    setaucbackbox(event.target.result);
                }
                else if (t == "2") {
                    setaucstampbox(event.target.result)
                }
                else if (t == "3") {
                    setaucustampbox(event.target.result)
                }
                else if (t == "4") {
                    setaucsponsorbox(event.target.result)
                }
                else if (t == "5") {
                    setaucbannerbox(event.target.result)
                }
            };
            reader.readAsDataURL(file);
        }
    };
    const handleColorChange = (event) => {
        setcolor(event.target.value);
    };
    const removefile = async (imgpoptype) => {
        if (imgpoptype == '3' || imgpoptype == '4' || imgpoptype == '5') {
            setActive(true);
            const id = toast.loading("Please wait...");

            let toastContainerId = toast.update(id, {
                render: "please wait...",
                theme: "dark",
                position: "bottom-center",
            });
            var hdr = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
                },
            };
            var vals = {}

            if (imgpoptype == '3') {
                vals.fltyp = 'bg';
            }
            else if (imgpoptype == '4') {
                vals.fltyp = 'sstamp';
            }
            else if (imgpoptype == '5') {
                vals.fltyp = 'usstamp';
            }
            await DataService.delfiles(vals, hdr)
                .then((res) => {
                    let response = res.data;
                    toast.dismiss(toastContainerId);

                    if (response.success == true) {
                        setisimgpop(false)
                        if (imgpoptype == '3') {
                            setaucdetail(detail => ({
                                ...detail,
                                more: [{ ...detail.more[0], bg: "" }]
                            }))
                        }
                        else if (imgpoptype == '4') {
                            setaucdetail(detail => ({
                                ...detail,
                                more: [{ ...detail.more[0], sstamp: "" }]
                            }))
                        }
                        else if (imgpoptype == '5') {
                            setaucdetail(detail => ({
                                ...detail,
                                more: [{ ...detail.more[0], usstamp: "" }]
                            }))
                        }
                        toast.success("Removed !!", {
                            theme: "colored",
                            position: "bottom-center",
                        });

                    } else {
                        if (response.msg != "")
                            toast.error(response.msg, { theme: "colored" });
                    }

                    setActive(false);
                })
                .catch(() => {
                    //  console.log("Not valid");
                    toast.error("Not valid Server Error", { theme: "colored" });
                    setActive(false);
                });
        }
        else if (imgpoptype == '2') {
            setActive(true);
            const id = toast.loading("Please wait...");

            let toastContainerId = toast.update(id, {
                render: "please wait...",
                theme: "dark",
                position: "bottom-center",
            });
            var hdr = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
                },
            };
            var vals = {}
            vals.i = imgpopdata.spnid

            await DataService.delspn(vals, hdr)
                .then((res) => {
                    let response = res.data;
                    toast.dismiss(toastContainerId);
                    if (response.success == true) {
                        const db = getDatabase();
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 14,
                                "upd": 2,
                                "val": imgpopdata.spnid,
                            }, "tkn": updtoken
                        });
                        setisimgpop(false)
                        setaucdetail(detail => ({
                            ...detail,
                            spn: detail.spn.filter((sp) => sp.spnid != imgpopdata.spnid)
                        }))
                        toast.success("Removed !!", {
                            theme: "colored",
                            position: "bottom-center",
                        });

                    } else {
                        if (response.msg != "")
                            toast.error(response.msg, { theme: "colored" });
                    }

                    setActive(false);
                })
                .catch(() => {
                    //  console.log("Not valid");
                    toast.error("Not valid Server Error", { theme: "colored" });
                    setActive(false);
                });
        }
        else if (imgpoptype == '1') {
            setActive(true);
            const id = toast.loading("Please wait...");

            let toastContainerId = toast.update(id, {
                render: "please wait...",
                theme: "dark",
                position: "bottom-center",
            });
            var hdr = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
                },
            };
            var vals = {}
            vals.i = imgpopdata.bnrid

            await DataService.delbnr(vals, hdr)
                .then((res) => {
                    let response = res.data;
                    toast.dismiss(toastContainerId);
                    if (response.success == true) {
                        const db = getDatabase()
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 15,
                                "upd": 2,
                                "val": { id: imgpopdata.bnrid },
                            }, "tkn": updtoken
                        });
                        setisimgpop(false)
                        setaucdetail(detail => ({
                            ...detail,
                            bnr: detail.bnr.filter((bn) => bn.bnrid != imgpopdata.bnrid)
                        }))
                        toast.success("Removed !!", {
                            theme: "colored",
                            position: "bottom-center",
                        });

                    } else {
                        if (response.msg != "")
                            toast.error(response.msg, { theme: "colored" });
                    }

                    setActive(false);
                })
                .catch(() => {
                    //  console.log("Not valid");
                    toast.error("Not valid Server Error", { theme: "colored" });
                    setActive(false);
                });
        }
    }

    const removeuploads = async (t) => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = {}
        if (t == '1') {
            vals.fltyp = 'bg';
        }
        else if (t == '2') {
            vals.fltyp = 'sstamp';
        }
        else if (t == '3') {
            vals.fltyp = 'usstamp';
        }
        await DataService.delfiles(vals, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);

                if (response.success == true) {
                    setisimgpop(false)
                    if (t == '1') {
                        setaucbackbox("")
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], bg: "" }]
                        }))
                        const db = getDatabase();
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 13,
                                "upd": 2,
                                "val": "",
                            }, "tkn": updtoken
                        });
                    }
                    else if (t == '2') {
                        setaucstampbox("")
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], sstamp: "" }]
                        }))
                    }
                    else if (t == '3') {
                        setaucustampbox("")
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], usstamp: "" }]
                        }))
                    }
                    toast.success("Removed !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });

                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const delfile = (t) => {
        confirmAlert({
            message: "Are you sure delete this record !",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => removeuploads(t),
                },
                {
                    label: "No",
                    // onClick: () => del(id, 0),
                },
            ],
        });
    };
    const del = useCallback(
        async (vl, status) => {
            if (status == 1) {
                setActive(true);

                var hdr = {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: JSON.stringify([{ cid: loginuser["cid"], token: loginuser["token"] }]),
                    },
                };

                await DataService.deleteAuction({ aid: encode(vl) }, hdr)
                    .then((res) => {
                        let response = res.data;
                        if (response.success == true) {
                            toast.success(response.msg, {
                                theme: "dark",
                                position: "bottom-center",
                            });

                            const updateitem = getpageData.responsedata.list.filter(
                                (ele, ind) => {
                                    if (ele.aid != vl) {
                                        return ele;
                                    }
                                }
                            );
                            let responsedata = {
                                responsedata: {
                                    path: getpageData.responsedata.path,
                                    cid: cid,
                                    list: updateitem,
                                },
                            };
                            dispatch(actlistData(responsedata));
                            history.push(BASE_PATH + "my-auction");
                            // const updateitem = data.list.filter((ele, ind) => {
                            //   return ele.aid != vl;
                            // });
                            // data.list = updateitem;
                            // setData(data);
                        } else {
                            toast.error(response.msg, {
                                theme: "colored",
                                position: "bottom-center",
                            });
                        }

                        setActive(false);
                    })
                    .catch(() => {
                        //  console.log("Not valid");
                        toast.error("Not valid Server Error", {
                            theme: "colored",
                            position: "bottom-center",
                        });
                        setActive(false);
                    });
            }
        },
        []
    );
    function showfullbg(ele) {
        setisfullbg(true)
        setbgfulldata(ele)
    }
    function handleDivClick(fl) {
        setselectedbgfl(fl)
        setthemebg(bgdata.path + fl)
    }
    function handleDivClick2(th) {
        //  console.log(th)
        settheme(th)
    }
    const themesubmit = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        //  console.log('aid')
        //  console.log(aid)
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = {}
        vals.bg = themebg.substring(themebg.lastIndexOf('/') + 1)
        vals.theme = theme
        vals.custom = {
            colors: {
                title_c: color,
                bid_c: color2,
                pl_name_dt_c: color3,
                border_c: color4,
                team_C: color5,
                pl_head_gc1: color6,
                pl_head_gc2: color7,
                pl_border_c: color8,
                pl_shadow_c: color9,
                pl_detail_bg_gc1: color10,
                pl_detail_bg_gc2: color11,
                pl_dt_shadow_c: color12,
                extra_dt_c: color13,
                mp_label_c: color14,
                mp_val_c: color15,
                pl_border_gc1: color16,
                pl_border_gc2: color17,
                mp_bg_gc1: color18,
                mp_bg_gc2: color19

            },
            fonts: {
                tema_f: teamfont,
                bid_f: bidfont,
                pl_name_f: plnamefont,
                pl_detail_f: pldetailfont,
                pl_data_f: maindetailfont,
                detail_f: detailfont,
            },
            display: {
                team_show: showteam,
                auc_head_show: showauctionhead,
                max_pl_show: showmax,
                extra_design_show: showextradesign
            }
        }
        await DataService.setmytheme(vals, hdr)
            .then((res) => {
                let response = res.data;
                //  console.log('theme submit response')
                //  console.log(response)
                //  console.log(vals)
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    var auccopy = aucdetail
                    auccopy.more[0].theme = theme
                    auccopy.more[0].bg = themebg
                    auccopy.custom = vals.custom
                    dispatch(actmore(auccopy));


                    toast.success("Effect set !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    // setaucbackbox(bgdata.path + selectedbgfl)
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const setfireworkeffect = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = {}
        // vals.fltyp = 'bg';
        vals.fireworks = selectedOption
        await DataService.setfirework(vals, hdr)
            .then((res) => {
                let response = res.data;
                //  console.log('firework response')
                //  console.log(response)
                //  console.log(vals)
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    setaucdetail(detail => ({
                        ...detail,
                        more: [{ ...detail.more[0], fireworks: selectedOption }]
                    }))

                    var auccopy = aucdetail
                    auccopy.more[0].fireworks = selectedOption
                    dispatch(actmore(auccopy));
                    // const db = getDatabase();
                    // set(ref(db, 'auction/info/' + aid), {
                    //   "type": "1", "upd": "6", 'id': aid, "detail": {
                    //     "typ": 13,
                    //     "upd": 1,
                    //     "val": { img: response.data.newentry.logo },
                    //   }, "tkn": updtoken
                    // });
                    // setisbgpop(false)
                    // setselectedbgfl("")

                    toast.success("Effect set !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    // setaucbackbox(bgdata.path + selectedbgfl)
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });

    }
    const setbg = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        var vals = {}
        vals.fltyp = 'bg';
        vals.fl = selectedbgfl
        await DataService.setbg(vals, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    const db = getDatabase();
                    set(ref(db, 'auction/info/' + aid), {
                        "type": "1", "upd": "6", 'id': aid, "detail": {
                            "typ": 13,
                            "upd": 1,
                            "val": { img: response.data.newentry.logo },
                        }, "tkn": updtoken
                    });
                    setisbgpop(false)
                    setselectedbgfl("")

                    toast.success("Background set !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    setaucbackbox(bgdata.path + selectedbgfl)
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });

    }
    const banneradd = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var hdr = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        const formData = new FormData();
        formData.append("bnrimg", aucbanner);

        await DataService.addbanner(formData, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                // //  console.log(response)
                if (response.success == true) {
                    const db = getDatabase()
                    set(ref(db, 'auction/info/' + aid), {
                        "type": "1", "upd": "6", 'id': aid, "detail": {
                            "typ": 15,
                            "upd": 1,
                            "val": response.data.newentry,
                        }, "tkn": updtoken
                    });
                    setaucbannerbox("")
                    fileInputRefs.current.forEach((ref) => {
                        if (ref.current) {
                            ref.current.value = '';
                        }
                    });
                    setaucdetail(prev => ({
                        ...prev,
                        bnr: [...prev.bnr, response.data.newentry]
                    }))
                    // //  console.log("setted")
                    toast.success("Banner Added !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });

                    setaucbanner("")
                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const sponsoradd = async () => {
        setActive(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var hdr = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        const formData = new FormData();
        formData.append("splogo", aucsponsor);
        await DataService.addsponsor(formData, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                // //  console.log(response)
                if (response.success == true) {
                    //  console.log('sponsor add response....!!')
                    //  console.log(response.success)
                    const db = getDatabase();
                    //  console.log('sponsor add response ddd....!!')

                    set(ref(db, 'auction/info/' + aid), {
                        "type": "1", "upd": "6", 'id': aid, "detail": {
                            "typ": 14,
                            "upd": 1,
                            "val": response.data.newentry,
                        }, "tkn": updtoken
                    });
                    // //  console.log("setted")
                    //  console.log('sponsor add response eee....!!')

                    setaucsponsorbox("")
                    fileInputRefs.current.forEach((ref) => {
                        if (ref.current) {
                            ref.current.value = '';
                        }
                    });
                    toast.success("Sponsor Added !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });
                    //  console.log('sponsor add response 22222....!!')

                    setaucdetail(prev => ({
                        ...prev,
                        spn: [...prev.spn, response.data.newentry]
                    }))

                    setaucsponsor("")
                } else {
                    //  console.log('sponsor add response 33333....!!')

                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }
                //  console.log('sponsor add response. 444...!!')

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    const chooseback = async () => {
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
            },
        };

        await DataService.bglist({}, hdr)
            .then((res) => {
                let response = res.data;
                if (response.success == true) {
                    setbgdata(response.data)
                    if (themebg == '') {
                        setthemebg(response.data.path + '241009155915341.png')
                    }


                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
        setisbgpop(!isbgpop)

    }
    const uploadfiles = async (typ) => {
        setActive(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var hdr = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        const formData = new FormData();
        if (typ == 'bg') {
            // if (aucbackbox == "") {

            //   formData.append("fl", aucback);
            // } else {
            //   alert('This background is already set !!')
            //   toast.dismiss(toastContainerId); // Dismiss the toast message here

            //   return 0
            // }
            formData.append("fl", aucback);

            const fileSizeKB = Math.round(aucback.size / 1024); // Convert bytes to kilobytes
            const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
            if (fileSizeMB > 1.25) {
                alert('File size must be less than 1.25Mb')
                toast.dismiss(toastContainerId);
                return 0
            }

        }
        else if (typ == 'sstamp') {
            formData.append("fl", aucsoldstamp);
            const fileSizeKB = Math.round(aucsoldstamp.size / 1024); // Convert bytes to kilobytes
            const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
            if (fileSizeMB > 1.25) {
                alert('File size must be less than 1.25Mb')
                toast.dismiss(toastContainerId);
                return 0
            }


        }
        else if (typ == 'usstamp') {
            formData.append("fl", aucunsoldstamp);
            const fileSizeKB = Math.round(aucunsoldstamp.size / 1024); // Convert bytes to kilobytes
            const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
            if (fileSizeMB > 1.25) {
                alert('File size must be less than 1.25Mb')
                toast.dismiss(toastContainerId);
                return 0
            }




        }

        formData.append("fltyp", typ);
        await DataService.addfiles(formData, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                if (response.success == true) {
                    if (typ == 'bg') {
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], bg: response.data.newentry.logo }]
                        }))
                        setaucback("")
                        const db = getDatabase();
                        set(ref(db, 'auction/info/' + aid), {
                            "type": "1", "upd": "6", 'id': aid, "detail": {
                                "typ": 13,
                                "upd": 1,
                                "val": { img: response.data.newentry.logo },
                            }, "tkn": updtoken
                        });

                    }
                    else if (typ == 'sstamp') {

                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], sstamp: response.data.newentry.logo }]
                        }))
                        setaucsoldstamp("")
                    }
                    else if (typ == 'usstamp') {
                        setaucdetail(detail => ({
                            ...detail,
                            more: [{ ...detail.more[0], usstamp: response.data.newentry.logo }]
                        }))
                        setaucunsoldstamp("")
                    }
                    // //  console.log("setted")
                    fileInputRefs.current.forEach((ref) => {
                        if (ref.current) {
                            ref.current.value = '';
                        }
                    });
                    toast.success("Added !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });

                    // setaucdetail(prev => ({
                    //   ...prev,
                    //   spn: [...prev.spn, response.data.newentry]
                    // }))

                } else {
                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    }
    function setimagepopup(item, t) {
        setisimgpop(true)
        setimgpopdata(item)
        setimgpoptype(t)
    }
    // function defaultset(){
    //     setcolor()
    //     setcolor2()
    //     setcolor3()
    //     setcolor4()
    //     setcolor5()
    //     setcolor6()
    //     setcolor7()
    //     setteamfont()
    //     setmaindetailfont()
    //     setdetailfont()
    //     setbidfont('')    }

    const resetColor = (colorType) => {
        console.log('colorType')
        console.log(colorType)
        // Get default color from theme or custom settings
        let defaultColor = '';

        if (aucmoredetail.custom?.colors && aucmoredetail.custom.colors[colorType]) {
            defaultColor = aucmoredetail.custom.colors[colorType];
        } else {
            // Theme defaults based on current theme
            const themeDefaults = {
                1: {
                    title_c: '#EDE07A',
                    bid_c: '#ffff00',
                    pl_name_dt_c: '#ffffff',
                    extra_dt_c: '#ffffff',
                    border_c: '#E98A3A',
                    team_C: '#ffffff',
                    pl_head_gc1: '#e38348',
                    pl_head_gc2: '#db1b2b',
                    pl_detail_bg_gc1: '#CBA543',
                    mp_label_c: '#CBA543',
                    mp_val_c: '#ffffff'
                },
                2: {
                    title_c: '#EDE07A',
                    bid_c: '#ffff00',
                    pl_name_dt_c: '#ffffff',
                    extra_dt_c: '#ffffff',
                    border_c: '#E98A3A',
                    team_C: '#ffffff',
                    pl_head_gc1: '#e38348',
                    pl_head_gc2: '#db1b2b',
                    mp_label_c: '#000000',
                    mp_val_c: '#ffffff',
                    pl_border_gc1: '#F1823B',
                    pl_border_gc2: '#EA4633',
                    mp_bg_gc1: '#EF7D39',
                    mp_bg_gc2: '#E74132'
                },
                6: {
                    title_c: '#230677',
                    bid_c: '#380d4b',
                    pl_name_dt_c: '#ffffff',
                    extra_dt_c: '#ffffff',
                    border_c: '#4a06a0',
                    team_C: '#ffffff',
                    pl_head_gc1: '#e38348',
                    pl_head_gc2: '#db1b2b',
                    pl_detail_bg_gc1: '#380d4b',
                    mp_label_c: '#3d0487',
                    mp_val_c: '#663399',
                    pl_border_gc1: '#3d0487',
                    pl_border_gc2: '#b45728'
                },
                8: {
                    title_c: '#ffffff',
                    bid_c: '#ffffff',
                    pl_name_dt_c: '#000000',
                    border_c: '#824E2E',
                    team_C: '#ffffff',
                    pl_border_c: '#d3ac1d',
                    pl_shadow_c: '#947b1e',
                    pl_detail_bg_gc1: '#bc791a',
                    pl_detail_bg_gc2: '#d3ac1d',
                    pl_dt_shadow_c: '#947b1e',
                    extra_dt_c: '#ffffff',
                    mp_label_c: '#CBA543',
                    mp_val_c: '#ffffff'
                },
                10: {
                    title_c: '#EDE07A',
                    bid_c: '#FFFF00',
                    pl_name_dt_c: '#ffffff',
                    border_c: '#8a2be2',
                    team_C: '#FFFF00',
                    pl_head_gc1: '#ffffff',
                    pl_head_gc2: '#ffffff',
                    pl_border_c: '#d3ac1d',
                    pl_shadow_c: '#947b1e',
                    pl_detail_bg_gc1: '#bc791a',
                    pl_detail_bg_gc2: '#d3ac1d',
                    pl_dt_shadow_c: '#947b1e',
                    extra_dt_c: '#ffffff',
                    mp_label_c: '#CBA543',
                    mp_val_c: '#ffffff',
                    pl_border_gc1: '#BD48D3',
                    pl_border_gc2: '#224AAA',
                    mp_bg_gc1: '#BD48D3',
                    mp_bg_gc2: '#224AAA'
                },
                12: {
                    title_c: '#EDE07A',
                    bid_c: '#FFFF00',
                    pl_name_dt_c: '#ffffff',
                    border_c: '#8a2be2',
                    team_C: '#FFFF00',
                    pl_head_gc1: '#ffffff',
                    pl_head_gc2: '#ffffff',
                    pl_border_c: '#d3ac1d',
                    pl_shadow_c: '#947b1e',
                    pl_detail_bg_gc1: '#bc791a',
                    pl_detail_bg_gc2: '#d3ac1d',
                    pl_dt_shadow_c: '#947b1e',
                    extra_dt_c: '#ffffff',
                    mp_label_c: '#CBA543',
                    mp_val_c: '#ffffff',
                    pl_border_gc1: '#BD48D3',
                    pl_border_gc2: '#224AAA',
                    mp_bg_gc1: '#BD48D3',
                    mp_bg_gc2: '#224AAA'
                },
                18: {
                    title_c: '#EDE07A',
                    bid_c: '#FFFF00',
                    pl_name_dt_c: '#000000',
                    border_c: '#8a2be2',
                    team_C: '#ffffff',
                    pl_head_gc1: '#ffffff',
                    pl_head_gc2: '#ffffff',
                    pl_border_c: '#d3ac1d',
                    pl_shadow_c: '#947b1e',
                    pl_detail_bg_gc1: '#cea44e',
                    pl_detail_bg_gc2: '#fdf4a7',
                    pl_dt_shadow_c: '#947b1e',
                    extra_dt_c: '#ffffff',
                    mp_label_c: '#000000',
                    mp_val_c: '#ffffff',
                    pl_border_gc1: '#ba842a',
                    pl_border_gc2: '#f7e981',
                    mp_bg_gc1: '#EF7D39',
                    mp_bg_gc2: '#E74132'
                }
            };
            console.log(themeDefaults[theme]?.[colorType])

            defaultColor = themeDefaults[theme]?.[colorType] || '#ffffff';
            console.log(defaultColor)
        }

        // Set the appropriate color state
        switch (colorType) {
            case 'title_c':
                setcolor(defaultColor);
                break;
            case 'bid_c':
                setcolor2(defaultColor);
                break;
            case 'pl_name_dt_c':
                setcolor3(defaultColor);
                break;
            case 'border_c':
                setcolor4(defaultColor);
                break;
            case 'team_C':
                setcolor5(defaultColor);
                break;
            case 'pl_head_gc1':
                setcolor6(defaultColor);
                break;
            case 'pl_head_gc2':
                setcolor7(defaultColor);
                break;
            case 'pl_border_c':
                setcolor8(defaultColor);
                break;
            case 'pl_shadow_c':
                setcolor9(defaultColor);
                break;
            case 'pl_detail_bg_gc1':
                setcolor10(defaultColor);
                break;
            case 'pl_detail_bg_gc2':
                setcolor11(defaultColor);
                break;
            case 'pl_dt_shadow_c':
                setcolor12(defaultColor);
                break;
            case 'extra_dt_c':
                setcolor13(defaultColor);
                break;
            case 'mp_label_c':
                setcolor14(defaultColor);
                break;
            case 'mp_val_c':
                setcolor15(defaultColor);
                break;
            case 'pl_border_gc1':
                setcolor16(defaultColor);
                break;
            case 'pl_border_gc2':
                setcolor17(defaultColor);
                break;
            case 'mp_bg_gc1':
                setcolor18(defaultColor);
                break;
            case 'mp_bg_gc2':
                setcolor19(defaultColor);
                break;
            case 'sub_title_c':
                setcolor20(defaultColor);
                break;
        }
    };

    return (
        <div>

            <Navigationtitle data={match} />
            <div className="custom_auction_theme">
                <div className='custom_options'>
                    <div className={`custom_options_child ${customtype == 'theme' && 'active_blue'}`} onClick={() => setcustomtype('theme')}>

                        <div>
                            <BsLayoutWtf />
                        </div>
                        <div>
                            <label htmlFor="">Theme</label>
                        </div>

                    </div>
                    <div className={`custom_options_child ${customtype == 'bg' && 'active_blue'}`} onClick={() => { setcustomtype('bg'); chooseback() }}>

                        <div>
                            <PiSelectionBackgroundFill />

                        </div>
                        <div>
                            <label htmlFor="">Background</label>
                        </div>

                    </div>
                    <div className={`custom_options_child ${customtype == 'data' && 'active_blue'}`} onClick={() => setcustomtype('data')}>

                        <div>
                            <TbListDetails />
                        </div>
                        <div>
                            <label htmlFor="">Content</label>
                        </div>
                    </div>
                    <div className={`custom_options_child`} onClick={() => askdefaultset()}>

                        <div>
                            <MdOutlineSettingsBackupRestore />
                        </div>
                        <div>
                            <label htmlFor="">Default</label>
                        </div>
                    </div>
                    <div className={`custom_options_child`} onClick={handleImportClick}>

                        <div>
                            <CiImport />
                        </div>
                        <div>
                            <label htmlFor="">Import</label>
                        </div>

                        <input
                            type="file"
                            id="fileInputt"
                            style={{ display: 'none' }}
                            accept=".json"
                            onChange={handlethemeFileChange}
                        />
                    </div>


                </div>
                <div className='Custom_available_options'>
                    {customtype == 'theme' &&
                        <>
                            <div className='backgrounds_container'>
                                <div className="custom_head">Choose Theme</div>
                                <div>
                                    {mythemes.map((ele, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className={`custom_option_image ${theme == ele.no ? 'active' : ''}`}
                                                onClick={() => handleDivClick2(ele.no)}
                                            >
                                                <img src={ele.img} alt="" />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </>
                    }
                    {customtype == 'bg' &&
                        <>
                            <div className='backgrounds_container'>
                                <div className="custom_head">Choose Backgrounds</div>
                                <div>
                                    {bgdata?.list?.map((ele, index) => {
                                        return (
                                            <div key={ele.fl} className={`custom_option_image`} onClick={() => handleDivClick(ele.fl)}>
                                                <img src={bgdata.path + ele.fl} alt="" />
                                            </div>
                                        )
                                    })}

                                </div>

                            </div>
                        </>
                    }
                    {customtype == 'data' &&
                        <>
                            <div className='backgrounds_container'>
                                <div className="custom_head">Customize</div>
                                <div className='custom_drawer' onClick={() => toggleDrawer('colors')}>
                                    <div className='main_col_label'>
                                        <IoColorPaletteOutline className='main_col_icon' />
                                        <label htmlFor=""> Colors</label>
                                    </div>
                                    {activeDrawer === 'colors' ? <FaChevronDown /> : <FaChevronRight />}

                                </div>
                                {activeDrawer === 'colors' &&
                                    <div ref={colorRef} className={`custom_color_div ${activeDrawer === 'colors' ? 'open' : ''}`}>

                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('title_c')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Title color</label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color}
                                                onChange={(e) => setcolor(e.target.value)}
                                            />
                                        </div>
                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('bid_c')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Bid color </label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color2}
                                                onChange={(e) => setcolor2(e.target.value)}
                                            />
                                        </div>
                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('pl_name_dt_c')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Name and Detail </label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color3}
                                                onChange={(e) => setcolor3(e.target.value)}
                                            />
                                        </div>
                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('extra_dt_c')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Extra detail </label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color13}
                                                onChange={(e) => setcolor13(e.target.value)}
                                            />
                                        </div>
                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('pl_detail_bg_gc1')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Sub-title </label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color20}
                                                onChange={(e) => setcolor20(e.target.value)}
                                            />
                                        </div>
                                        {(theme == 1 || theme == 2 || theme == 6 || theme == 10) && <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('border_c')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Border </label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color4}
                                                onChange={(e) => setcolor4(e.target.value)}
                                            />
                                        </div>}
                                        {(theme == 6 || theme == 2 || theme == 10 || theme == 18) &&
                                            <div className='custom_color_options'>
                                                <div className='col_label'>
                                                    <IoColorPaletteOutline
                                                        className='col_icon'
                                                        onClick={() => resetColor('pl_border_gc1')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                    <label htmlFor="">Player Border </label>
                                                </div>
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color16}
                                                    onChange={(e) => setcolor16(e.target.value)}
                                                />
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color17}
                                                    onChange={(e) => setcolor17(e.target.value)}
                                                />
                                            </div>
                                        }
                                        {(theme == 8) &&
                                            <div className='custom_color_options'>
                                                <div className='col_label'>
                                                    <IoColorPaletteOutline
                                                        className='col_icon'
                                                        onClick={() => resetColor('pl_border_c')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                    <label htmlFor="">Player Border </label>
                                                </div>
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color8}
                                                    onChange={(e) => setcolor8(e.target.value)}
                                                />
                                            </div>
                                        }
                                        {(theme == 8) &&
                                            <div className='custom_color_options'>
                                                <div className='col_label'>
                                                    <IoColorPaletteOutline
                                                        className='col_icon'
                                                        onClick={() => resetColor('pl_shadow_c')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                    <label htmlFor="">Player Shadow </label>
                                                </div>
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color9}
                                                    onChange={(e) => setcolor9(e.target.value)}
                                                />
                                            </div>
                                        }
                                        {(theme == 8 || theme == 6 || theme == 1 || theme == 18) &&
                                            <div className='custom_color_options'>
                                                <div className='col_label'>
                                                    <IoColorPaletteOutline
                                                        className='col_icon'
                                                        onClick={() => resetColor('pl_detail_bg_gc1')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                    <label htmlFor="">Detail BG </label>
                                                </div>
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color10}
                                                    onChange={(e) => setcolor10(e.target.value)}
                                                />
                                                {(theme == 8 || theme == 18) && <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color11}
                                                    onChange={(e) => setcolor11(e.target.value)}
                                                />}

                                            </div>
                                        }
                                        {(theme == 8) &&
                                            <div className='custom_color_options'>
                                                <div className='col_label'>
                                                    <IoColorPaletteOutline
                                                        className='col_icon'
                                                        onClick={() => resetColor('pl_dt_shadow_c')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                    <label htmlFor="">Detail Shadow </label>
                                                </div>
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color12}
                                                    onChange={(e) => setcolor12(e.target.value)}
                                                />
                                            </div>


                                        }
                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('team_C')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Team</label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color5}
                                                onChange={(e) => setcolor5(e.target.value)}
                                            />
                                        </div>
                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('mp_label_c')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Max/Player Label</label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color14}
                                                onChange={(e) => setcolor14(e.target.value)}
                                            />
                                        </div>
                                        <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('mp_val_c')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Max/Player Value</label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color15}
                                                onChange={(e) => setcolor15(e.target.value)}
                                            />
                                        </div>
                                        {(theme == 2 || theme == 10 || theme == 18) && <div className='custom_color_options'>
                                            <div className='col_label'>
                                                <IoColorPaletteOutline
                                                    className='col_icon'
                                                    onClick={() => resetColor('mp_bg_gc1')}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <label htmlFor="">Max/Player BG</label>
                                            </div>
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color18}
                                                onChange={(e) => setcolor18(e.target.value)}
                                            />
                                            <input
                                                type="color"
                                                className='color_inp rounded-color-input'
                                                value={color19}
                                                onChange={(e) => setcolor19(e.target.value)}
                                            />
                                        </div>}
                                        {
                                            <div className='custom_color_options'>
                                                <div className='col_label'>
                                                    <IoColorPaletteOutline
                                                        className='col_icon'
                                                        onClick={() => resetColor('pl_detail_bg_gc2')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                    <label htmlFor="">Sub-title-bg</label>
                                                </div>
                                                <span>{isplbg ? <IoEyeOutline className='col_icon pointer_ic' onClick={() => setisplbg(false)} /> : <BiHide className='pointer_ic' onClick={() => setisplbg(true)} />}</span>
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color6}
                                                    onChange={(e) => setcolor6(e.target.value)}
                                                />
                                                <input
                                                    type="color"
                                                    className='color_inp rounded-color-input'
                                                    value={color7}
                                                    onChange={(e) => setcolor7(e.target.value)}
                                                />
                                            </div>
                                        }


                                    </div>
                                }
                                {/* <div className='custom_drawer' onClick={() => toggleDrawer('fonts')}>
                                    <div className='main_col_label'>
                                        <ImFontSize className='main_col_icon' />
                                        <label htmlFor=""> Fonts</label>
                                    </div>
                                    {activeDrawer === 'fonts' ? <FaChevronDown /> : <FaChevronRight />}

                                </div> */}
                                {activeDrawer === 'fonts' &&
                                    <div ref={fontRef} className={`custom_font_div ${activeDrawer === 'fonts' ? 'open' : ''}`}>
                                        <div className='custom_div_options'>
                                            <div className="font_custom_justify">
                                                <div className='col_label'>
                                                    <ImFontSize className='col_icon' />
                                                    <label htmlFor="">Bid Font</label>
                                                </div>
                                                <span>{bidfont}px</span>
                                            </div>
                                            <div>
                                                <input type="range" className='fontinputs' value={bidfont} onChange={(e) => setbidfont(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='custom_div_options'>
                                            <div className="font_custom_justify">
                                                <div className='col_label'>
                                                    <ImFontSize className='col_icon' />
                                                    <label htmlFor="">Team Font</label>
                                                </div>
                                                <span>{teamfont}px</span>
                                            </div>
                                            <div>

                                                <input type="range" min="10" max="100" className='fontinputs' value={teamfont} onChange={(e) => setteamfont(e.target.value)} />
                                            </div>
                                        </div>
                                        {(theme == 1 || theme == 2 || theme == 6 || theme == 10) && <div className='custom_div_options'>
                                            <div className="font_custom_justify">
                                                <div className='col_label'>
                                                    <ImFontSize className='col_icon' />
                                                    <label htmlFor="">Player's Data Font</label>
                                                </div>
                                                <span>{maindetailfont}px</span>
                                            </div>
                                            <div>

                                                <input type="range" className='fontinputs' value={maindetailfont} onChange={(e) => setmaindetailfont(e.target.value)} />
                                            </div>
                                        </div>}
                                        {theme == 8 &&
                                            <>
                                                <div className='custom_div_options'>
                                                    <div className="font_custom_justify">
                                                        <div className='col_label'>
                                                            <ImFontSize className='col_icon' />
                                                            <label htmlFor="">Player Name</label>
                                                        </div>
                                                        <span>{plnamefont}px</span>
                                                    </div>
                                                    <div>

                                                        <input type="range" className='fontinputs' value={plnamefont} onChange={(e) => setplnamefont(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className='custom_div_options'>
                                                    <div className="font_custom_justify">
                                                        <div className='col_label'>
                                                            <ImFontSize className='col_icon' />
                                                            <label htmlFor="">Player Detail</label>
                                                        </div>
                                                        <span>{pldetailfont}px</span>
                                                    </div>
                                                    <div>

                                                        <input type="range" className='fontinputs' value={pldetailfont} onChange={(e) => setpldetailfont(e.target.value)} />
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <div className='custom_div_options'>
                                            <div className="font_custom_justify">
                                                <div className='col_label'>
                                                    <ImFontSize className='col_icon' />
                                                    <label htmlFor="">Details Font</label>
                                                </div>
                                                <span>{detailfont}px</span>
                                            </div>
                                            <div>

                                                <input type="range" className='fontinputs' value={detailfont} onChange={(e) => setdetailfont(e.target.value)} />
                                            </div>
                                        </div>


                                    </div>
                                }
                                <div className='custom_drawer' onClick={() => toggleDrawer('display')}>
                                    <div className='main_col_label'>
                                        <IoEyeOutline className='main_col_icon' />
                                        <label htmlFor="">Display</label>
                                    </div>
                                    {activeDrawer === 'display' ? <FaChevronDown /> : <FaChevronRight />}

                                </div>
                                {activeDrawer === 'display' &&
                                    <div ref={displayref} className={`custom_font_div ${activeDrawer === 'display' ? 'open' : ''}`}>
                                        <div className='custom_div_options'>
                                            <div className="font_custom_justify">
                                                <div className='col_label'>

                                                    <label htmlFor="">Team name</label>
                                                </div>
                                                <span>{showteam ? <IoEyeOutline className='col_icon pointer_ic' onClick={() => setshowteam(false)} /> : <BiHide className='pointer_ic' onClick={() => setshowteam(true)} />}</span>
                                            </div>

                                        </div>
                                        <div className='custom_div_options'>
                                            <div className="font_custom_justify">
                                                <div className='col_label'>
                                                    <label htmlFor="">Auction heading</label>
                                                </div>
                                                <span>{showauctionhead ? <IoEyeOutline className='col_icon pointer_ic' onClick={() => setshowauctionhead(false)} /> : <BiHide className='pointer_ic' onClick={() => setshowauctionhead(true)} />}</span>
                                            </div>

                                        </div>
                                        <div className='custom_div_options'>
                                            <div className="font_custom_justify">
                                                <div className='col_label'>
                                                    <label htmlFor="">Max points/player</label>
                                                </div>
                                                <span>{showmax ? <IoEyeOutline className='col_icon pointer_ic' onClick={() => setshowmax(false)} /> : <BiHide className='pointer_ic' onClick={() => setshowmax(true)} />}</span>
                                            </div>

                                        </div>
                                        {theme == 8 &&

                                            <div className='custom_div_options'>
                                                <div className="font_custom_justify">
                                                    <div className='col_label'>
                                                        <label htmlFor="">Extra design</label>
                                                    </div>
                                                    <span>{showextradesign ? <IoEyeOutline className='col_icon pointer_ic' onClick={() => setshowextradesign(false)} /> : <BiHide className='pointer_ic' onClick={() => setshowextradesign(true)} />}</span>
                                                </div>

                                            </div>
                                        }
                                    </div>
                                }

                            </div>
                        </>
                    }

                </div>
                <div className='custom_preview' >
                    {theme == 2 &&
                        <div class="pgchild theme2 pg_a"
                            style={{
                                backgroundImage: `url(${themebg})`,
                                backgroundSize: 'cover', // Make sure background covers the entire div
                                backgroundPosition: 'center' // Center the background image
                            }} >


                            <div id="stars"></div>
                            <div id="stars2"></div>
                            <div id="stars3"></div>
                            <div class="grouptbnamelist">

                            </div>
                            <div class="spnlogopos">
                                <img src="https://mscspa.s3.amazonaws.com/sponsor/33278240927131566419.png" id="spn_lg_1" class="spn_lg spn_lg_1" />


                            </div>

                            {/* <div class="hddiv1" >
                            <img src="/manage/images/background/spabgsold.jpg" />
                        </div> */}



                            <div class="leaguename">
                                <div class="clubname" style={{ color: color }}><div>{aucmoredetail?.detail?.auctionname}</div></div> <span className='title_tag' style={{ display: `${!showauctionhead ? 'none' : 'block'}` }}> <span className='playerauctionbg' style={{ background: isplbg ? `linear-gradient(45deg, ${color6} 0%, ${color6} 32%, ${color7} 55%, ${color7} 100%, ${color7} 100%)` : 'transparent', color: color20 }}>  PLAYERS</span> AUCTION </span>  </div>
                            <div class="auctionlogo auctionstart">

                                <img src={aucmoredetail?.path + aucmoredetail?.detail.logo} />
                            </div>
                            <div class="plcode" style={{ background: `linear-gradient(to right, ${color16}, ${color17})` }} >81</div>

                            <div class="spalogo auctionstart">
                                <img src="https://superplayerauction.com/manage/images/background/superplwhite.png" />
                            </div>
                            <div class="alertmsg"></div>
                            <div class="playerdetail2" ></div>

                            <div class="playerdetail" >

                                <div class="photobgmfcl"></div>
                                <div class="phfram2">

                                </div>
                                <div class="phfram1">

                                </div>
                                <div class="iswkp"></div>
                                <div class="isage"></div>
                                <div id="pic" style={{ background: `linear-gradient(50deg,${color16}, ${color17})` }}>
                                    <div class="polyout">
                                        <div class="polyin">
                                            <img src="https://mscspa.s3.amazonaws.com/playersphoto/1728977074_24638.png?c" />
                                        </div>
                                    </div>
                                </div>
                                <div class="playertext">
                                    <div id="playername" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px` }}>Bhupendra singh&nbsp;</div>
                                    <div id="playertyp" style={{ border: `2px solid ${color4}`, color: color3 }}>All rounder&nbsp;</div>

                                    <div id="playerage" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px` }}> 22 <span class="yrs">YRS</span></div>
                                    <div class="baseamt " ></div>
                                </div>

                            </div>
                            <div class="isrunwkt">

                            </div>
                            <div class="playerbase">

                                <div class="tp"></div>


                                <div class="val">25000</div>
                                <div class="btm"></div>
                                <div class="lbl">BASE VALUE</div>

                            </div>
                            <div class="extdetail" style={{ color: color13, fontSize: `${detailfont}px` }} ><div>New India Titans</div></div>
                            <div class="bidby" >
                                <div id="selteamlogo">
                                    <img src={teamdefaultLogo} />

                                </div>
                                <div id="selteamname" style={{ display: `${!showteam ? 'none' : 'flex'}`, color: color5, fontSize: `${teamfont}px` }}>CC MAUERICKS</div>

                            </div>
                            <div class="bidby" >
                                {/* <div id="selteamlogo">
                                <img src="https://superplayerauction.com/manage/images/team-logo.png" />

                            </div> */}
                                <div id="selteamname"></div>

                            </div>
                            <div class="teammax" style={{ display: `${!showmax ? 'none' : 'block'}` }}>
                                <div class="teammaxpl maxpn" style={{ border: `2px solid ${color19}`, background: `linear-gradient(90deg, ${color18} 0%, ${color19} 100%) content-box` }}>
                                    <div style={{ color: color14 }} class="lbl">MAX<br />BID</div>
                                    <div style={{ color: color15 }} id="selteammaxpoint" class="val">308.5</div>
                                    <div class="clr"></div>
                                </div>
                                <div class="teammaxpl getpl" style={{ border: `2px solid ${color19}`, background: `linear-gradient(90deg, ${color18} 0%, ${color19} 100%) content-box` }}>
                                    <div style={{ color: color14 }} class="lbl">PLAYERS</div>
                                    <div style={{ color: color15 }} id="selteamtotalplayer" class="val">2/18</div>
                                    <div class="clr"></div>
                                </div>
                            </div>
                            <div id="auctionpoint" style={{ color: color2, fontSize: `${bidfont}px` }} >11.0<span class="pointtyp" style={{ fontSize: `${bidfont / 2}px` }}> LAC</span></div>
                            <div id="auctionpoint" ></div>
                        </div>
                    }
                    {theme == 1 &&
                        <div class="pgchild theme1 pg_2 pg_a"
                            style={{
                                backgroundImage: `url(${themebg})`,
                                backgroundSize: 'cover', // Make sure background covers the entire div
                                backgroundPosition: 'center' // Center the background image
                            }}  >

                            <div id="stars"></div>
                            <div id="stars2"></div>
                            <div id="stars3"></div>
                            <div class="grouptbnamelist">

                            </div>
                            <div class="leaguename">
                                <div class="clubname auction" style={{ color: color }}>{aucmoredetail?.detail.auctionname}<div><div class="clubname_season" style={{ display: `${!showauctionhead ? 'none' : 'block'}` }}> <span style={{ background: isplbg ? `linear-gradient(45deg, ${color6} 0%, ${color6} 32%, ${color7} 55%, ${color7} 100%, ${color7} 100%)` : 'transparent', color: color20 }}> PLAYER</span> AUCTION </div></div></div>    </div>
                            <div class="auctionlogo auctionstart">

                                <img src={aucmoredetail?.path + aucmoredetail?.detail.logo} />
                            </div>
                            <div class="plcode auction" >416</div>

                            <div class="spalogo auctionstart">
                                <img src="https://superplayerauction.com/manage/images/background/superplwhite.png" />
                            </div>
                            <div class="playerdetail auction" >
                                <div class="photobgmfcl"></div>
                                <div class="phfram2">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME2.png?a" />
                                </div>
                                <div class="phfram1">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME1.png?a" />

                                </div>
                                <div class="iswkp"><span><img src="https://superplayerauction.com/manage/images/ball.png" /></span><span><img src="https://superplayerauction.com/manage/images/bat.png" /></span></div>
                                <div class="isage"> 22 <span class="yrs">YRS</span></div>
                                <div id="pic">
                                    <div class="polyout">
                                        <div class="polyin">
                                            <img src="https://mscspa.s3.amazonaws.com/playersphoto/1728977074_24638.png?c" />
                                        </div>
                                    </div>
                                </div>
                                <div class="playertext">
                                    <div id="playername" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px`, background: color10 }}>Bhupendra singh&nbsp;</div>
                                    <div id="playertyp" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px`, background: color10 }}>All-rounder Bowler&nbsp;</div>

                                    <div id="playerage" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px`, background: color10 }}>Right Armed Player</div>
                                    <div class="baseamt"></div>
                                </div>

                            </div>
                            <div class="extdetail auction" style={{ color: color13, fontSize: `${detailfont}px` }} ><div>Shankar Nagar Kumhari</div></div>
                            <div class="bidby" >
                                <div id="selteamlogo">
                                    <img src={teamdefaultLogo} />

                                </div>
                                <div id="selteamname" style={{ display: `${!showteam ? 'none' : 'flex'}`, color: color5, fontSize: `${teamfont}px` }}>CHENNAI SUPER KINGS</div>

                            </div>
                            <div class="teammax" style={{ display: `${!showmax ? 'none' : 'block'}` }} >
                                <span style={{ color: color14 }} class="lbl">MAX</span>
                                <span style={{ color: color15 }} id="selteammaxpoint" >14100.0</span> &nbsp;
                                <span style={{ color: color14 }} class="lbl">P</span>
                                <span style={{ color: color15 }} id="selteamtotalplayer" >9/13</span>
                            </div>

                            <div id="auctionpoint" style={{ color: color2, fontSize: `${bidfont}px` }} >180.0<span class="pointtyp"> lakh</span></div>

                        </div>
                    }
                    {
                        theme == 6 &&
                        <div class="pgchild theme6 pg_2 pg_a"
                            style={{
                                backgroundImage: `url(${themebg})`,
                                backgroundSize: 'cover', // Make sure background covers the entire div
                                backgroundPosition: 'center' // Center the background image
                            }}
                        >

                            <div id="stars"></div>
                            <div id="stars2"></div>
                            <div id="stars3"></div>
                            <div class="grouptbnamelist">

                            </div>

                            <div class="spnlogopos">
                                <img src="https://mscspa.s3.amazonaws.com/sponsor/29390240910172915109.jpg" id="spn_lg_1" class="spn_lg spn_lg_1" />

                            </div>

                            {/* <div class="hddiv1" >
                                <img src="https://superplayerauction.com/manage/images/background/spabgsold.jpg" />
                            </div> */}

                            {/* <div id="hammercount" style="display: none;">8</div> */}

                            <div class="leaguename">
                                <div class="clubname auction" style={{ color: color }}>{aucmoredetail?.detail.auctionname}<div><div class="clubname_season" style={{ display: `${!showauctionhead ? 'none' : 'block'}` }}> <span style={{ background: isplbg ? `linear-gradient(45deg, ${color6} 0%, ${color6} 32%, ${color7} 55%, ${color7} 100%, ${color7} 100%)` : 'transparent', color: color20 }}>PLAYER</span>  AUCTION </div></div></div>    </div>
                            <div class="auctionlogo auctionstart">

                                <img src={aucmoredetail?.path + aucmoredetail?.detail.logo} />
                            </div>
                            <div class="plcode auction" style={{ background: `linear-gradient(to right, ${color16}, ${color17})` }} >414</div>

                            <div class="spalogo auctionstart">
                                <img src="https://superplayerauction.com/manage/images/background/superplwhite.png" />
                            </div>
                            <div class="alertmsg"></div>
                            <div class="playerdetail auction" >

                                {/* <div class="photobgmfcl"></div>
                                <div class="phfram2">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME2.png?a" />
                                </div>
                                <div class="phfram1">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME1.png?a" />

                                </div> */}
                                <div class="iswkp"><span><img src="https://superplayerauction.com/manage/images/bat.png" /></span><span><img src="https://superplayerauction.com/manage/images/ball.png" /></span></div>
                                <div class="isage"> 22<span class="yrs">YRS</span></div>
                                <div id="pic" style={{ background: `linear-gradient(50deg,${color16}, ${color17})` }}>
                                    <div class="polyout">
                                        <div class="polyin">
                                            <img src="https://mscspa.s3.amazonaws.com/playersphoto/1728977074_24638.png?c" />
                                        </div>
                                    </div>
                                </div>
                                <div class="playertext">
                                    <div id="playername" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px`, background: `${color10}` }}>Bhupendra singh&nbsp;</div>
                                    <div id="playertyp" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px`, background: `${color10}` }}>Batsman, Bowler&nbsp;</div>

                                    <div id="playerage" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px`, background: `${color10}` }}>Right Armed Player</div>
                                    <div class="baseamt"></div>
                                </div>

                            </div>
                            {/* <div style="position: absolute; " class="isrunwkt">

                                    </div> */}
                            {/* <div style="position: absolute; display: none; " class="playerbase">

                                        <div class="tp"></div>


                                        <div class="val">25000</div>
                                        <div class="btm"></div>
                                        <div class="lbl">BASE VALUE</div>

                                    </div> */}
                            <div class="extdetail auction" style={{ color: color13, fontSize: `${detailfont}px` }}  ><div>Super Silver<br />Birgao</div></div>
                            <div class="bidby" >
                                <div id="selteamlogo">
                                    <img src={teamdefaultLogo} />

                                </div>
                                <div id="selteamname" style={{ display: `${!showteam ? 'none' : 'flex'}`, color: color5, fontSize: `${teamfont}px` }}>CHENNAI SUPER KINGS</div>

                            </div>
                            <div class="teammax" style={{ display: `${!showmax ? 'none' : 'block'}` }} >
                                <span style={{ color: color14 }} class="lbl">MAX</span>
                                <span style={{ color: color15 }} id="selteammaxpoint" >14100.0</span> &nbsp;
                                <span style={{ color: color14 }} class="lbl">P</span>
                                <span style={{ color: color15 }} id="selteamtotalplayer" >9/13</span>
                            </div>

                            <div id="auctionpoint" style={{ color: color2, fontSize: `${bidfont}px` }} >180.0<span class="pointtyp"> lakh</span></div>

                            {/* <div class="soldviewx soldoutteam" style="display: none;">
                                        <div style="text-align: right;" id="selteamlogo">
                                            <img id="soldoutteamlogo" src="https://mscspa.s3.amazonaws.com/teams/1713606857_79524.png">
                                        </div>
                                        <div id="soldoutteamname"></div>
                                        <div class="soldteammax">
                                            <span style=" display:contents" class="lbl">MAX</span>
                                            <span id="selteammaxpoint" style=" display:contents"></span> &nbsp;
                                            <span style="" class="lbl">P</span>
                                            <span id="selteamtotalplayer" style=""></span>
                                        </div>
                                    </div> */}

                        </div>
                    }
                    {theme == 8 &&
                        <div class="pgchild theme8 pg_2 pg_a"
                            style={{
                                backgroundImage: `url(${themebg})`,
                                backgroundSize: 'cover', // Make sure background covers the entire div
                                backgroundPosition: 'center' // Center the background image
                            }}  >

                            <div id="stars"></div>
                            <div id="stars2"></div>
                            <div id="stars3"></div>
                            <div class="grouptbnamelist">

                            </div>
                            <div class="spnlogopos">
                                <img src="https://mscspa.s3.amazonaws.com/sponsor/29390240910172915109.jpg" id="spn_lg_1" class="spn_lg spn_lg_1" />

                            </div>

                            {/* <div class="hddiv1" >
                                <img src="https://superplayerauction.com/manage/images/background/spabgsold.jpg" />
                            </div> */}

                            {/* <div id="hammercount" >4</div> */}

                            <div class="leaguename">
                                <div class="clubname auction"><div style={{ display: `${!showextradesign ? 'none' : 'block'}` }}><img src="https://superplayerauction.com/manage/images/theme8/ornament_1.png" class="ornament_1" /></div><div style={{ color: color }}>{aucmoredetail?.detail.auctionname}</div><div><div class="clubname_season" style={{ display: `${!showauctionhead ? 'none' : 'block'}` }}> <span style={{ background: isplbg ? `linear-gradient(45deg, ${color6} 0%, ${color6} 32%, ${color7} 55%, ${color7} 100%, ${color7} 100%)` : 'transparent', color: color20 }}>PLAYER</span>  AUCTION </div></div><div style={{ display: `${!showextradesign ? 'none' : 'block'}` }}><img src="https://superplayerauction.com/manage/images/theme8/ornament_2.png" class="ornament_2" /></div></div>    </div>
                            <div class="auctionlogo auctionstart">

                                <img src={aucmoredetail?.path + aucmoredetail?.detail.logo} />
                            </div>
                            <div class="plcode auction" style={{ background: `linear-gradient(175deg, ${color10} 0%, ${color11}  100%)`, boxShadow: `0.5px 0.5px 0px ${color12}, 1px 1px 0px ${color12}, 1.5px 1.5px 0px ${color12}, 2px 2px 0px ${color12}, 2.5px 2.5px 0px ${color12}, 3px 3px 0px ${color12}, 3.5px 3.5px 0px ${color12}, 4px 4px 0px ${color12}, 4.5px 4.5px 0px ${color12}` }}  >402</div>

                            <div class="spalogo auctionstart">
                                <img src="https://superplayerauction.com/manage/images/background/superplwhite.png" />
                            </div>
                            <div class="alertmsg"></div>

                            <div class="playerdetail auction" >

                                <div class="photobgmfcl"></div>
                                {/* <div class="phfram2">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME2.png?a" />
                                </div>
                                <div class="phfram1">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME1.png?a" />

                                </div> */}
                                <div class="iswkp"><span><img src="https://superplayerauction.com/manage/images/bat.png" /></span><span><img src="https://superplayerauction.com/manage/images/ball.png" /></span></div>
                                {/* <div class="isage"> 42 <span class="yrs">YRS</span></div> */}
                                <div id="pic" style={{ boxShadow: `0.5px 0.5px 0px ${color9}, 1px 1px 0px ${color9}, 1.5px 1.5px 0px ${color9}, 2px 2px 0px ${color9}, 2.5px 2.5px 0px ${color9}, 3px 3px 0px ${color9}, 3.5px 3.5px 0px ${color9}, 4px 4px 0px ${color9}, 4.5px 4.5px 0px ${color9}` }}>
                                    <div class="polyout">
                                        <div class="polyin">
                                            <img style={{ background: `${color8}` }} src="https://mscspa.s3.amazonaws.com/playersphoto/1728977074_24638.png?c" />
                                        </div>
                                    </div>
                                </div>
                                <div class="playertext" style={{ background: `linear-gradient(175deg, ${color10} 0%, ${color11}  100%)`, boxShadow: `0.5px 0.5px 0px ${color12}, 1px 1px 0px ${color12}, 1.5px 1.5px 0px ${color12}, 2px 2px 0px ${color12}, 2.5px 2.5px 0px ${color12}, 3px 3px 0px ${color12}, 3.5px 3.5px 0px ${color12}, 4px 4px 0px ${color12}, 4.5px 4.5px 0px ${color12}` }} >
                                    <div id="playername" style={{ fontSize: `${plnamefont}px`, color: color3 }}  >Bhupendra singh&nbsp;</div>
                                    <div id="playertyp" style={{ fontSize: `${pldetailfont}px`, color: color3 }} >All-rounder Batsman&nbsp;</div>

                                    <div id="playerage" style={{ fontSize: `${pldetailfont}px `, color: color3 }} >Right Armed Player</div>
                                    <div class="baseamt"></div>
                                </div>

                            </div>

                            {/* <div class="playerbase">

                                <div class="tp"></div>


                                <div class="val">25000</div>
                                <div class="btm"></div>
                                <div class="lbl">BASE VALUE</div>

                            </div> */}
                            <div class="extdetail auction" style={{ fontSize: `${detailfont}px`, color: color13 }} ><div>Mana</div></div>
                            <div class="bidby" >
                                <div id="selteamlogo">
                                    <img src={teamdefaultLogo} />

                                </div>
                                <div id="selteamname" style={{ display: `${!showteam ? 'none' : 'flex'}`, color: color5, fontSize: `${teamfont}px` }}>CHENNAI SUPER KINGS</div>

                            </div>
                            <div class="teammax" style={{ display: `${!showmax ? 'none' : 'block'}` }} >
                                <span style={{ color: color14 }} class="lbl">MAX</span>
                                <span style={{ color: color15 }} id="selteammaxpoint" >14100.0</span> &nbsp;
                                <span style={{ color: color14 }} class="lbl">P</span>
                                <span style={{ color: color15 }} id="selteamtotalplayer" >9/13</span>
                            </div>

                            <div id="auctionpoint" style={{ color: color2, fontSize: `${bidfont}px` }} >180.0<span class="pointtyp"> lakh</span></div>


                            {/* <div class="soldviewx soldoutteam" style="display: none;">
                                        <div style="text-align: right;" id="selteamlogo">
                                            <img id="soldoutteamlogo" src="https://mscspa.s3.amazonaws.com/teams/1713606857_79524.png"/>
                                        </div>
                                        <div id="soldoutteamname"></div>
                                        <div class="soldteammax">
                                            <span style=" display:contents" class="lbl">MAX</span>
                                            <span id="selteammaxpoint" style=" display:contents"></span> &nbsp;
                                            <span style="" class="lbl">P</span>
                                            <span id="selteamtotalplayer" style=""></span>
                                        </div>
                                    </div> */}

                        </div>
                    }
                    {theme == 10 &&
                        <div class="pgchild  theme10 pg_2 pg_a"

                            style={{
                                backgroundImage: `url(${themebg})`,
                                backgroundSize: 'cover', // Make sure background covers the entire div
                                backgroundPosition: 'center' // Center the background image
                            }}  >

                            <div id="stars"></div>
                            <div id="stars2"></div>
                            <div id="stars3"></div>
                            <div class="grouptbnamelist">

                            </div>
                            <div class="spnlogopos">
                                <img src="https://mscspa.s3.amazonaws.com/sponsor/29390240910172915109.jpg" id="spn_lg_1" class="spn_lg spn_lg_1" />

                            </div>




                            <div class="leaguename">
                                <div class="clubname" style={{ color: color }}><div>{aucmoredetail?.detail.auctionname}</div></div> <span className='title_tag' style={{ display: `${!showauctionhead ? 'none' : 'block'}` }}> <span className='playerauctionbg' style={{ background: isplbg ? `linear-gradient(45deg, ${color6} 0%, ${color6} 32%, ${color7} 55%, ${color7} 100%, ${color7} 100%)` : 'transparent', color: color20 }}>PLAYERS</span> AUCTION </span>  </div>
                            <div class="auctionlogo auctionstart">

                                <img src={aucmoredetail?.path + aucmoredetail?.detail.logo} />
                            </div>
                            <div class="plcode auction" style={{ background: `linear-gradient(50deg,${color16}, ${color17})` }} >379</div>

                            <div class="spalogo auctionstart">
                                <img src="https://superplayerauction.com/manage/images/background/superplwhite.png" />
                            </div>
                            <div class="alertmsg"></div>

                            <div class="playerdetail auction" >

                                {/* <div class="photobgmfcl"></div>
                                <div class="phfram2">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME2.png?a" />
                                </div>
                                <div class="phfram1">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME1.png?a" />

                                </div> */}
                                <div class="iswkp"><span><img src="https://superplayerauction.com/manage/images/ball.png" /></span></div>
                                <div class="isage"> 31 <span class="yrs">YRS</span></div>
                                <div id="pic" style={{ background: `linear-gradient(50deg,${color16}, ${color17})` }}>
                                    <div class="polyout">
                                        <div class="polyin">
                                            <img src="https://mscspa.s3.amazonaws.com/playersphoto/1728977074_24638.png?c" />
                                        </div>
                                    </div>
                                </div>
                                <div class="playertext">
                                    <div id="playername" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px` }}>Bhupendra singh&nbsp;</div>
                                    <div id="playertyp" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px` }}>Bowler&nbsp;</div>

                                    <div id="playerage" style={{ border: `2px solid ${color4}`, color: color3, fontSize: `${maindetailfont}px` }}>Right Armed Player</div>
                                    <div class="baseamt"></div>
                                </div>

                            </div>

                            <div class="extdetail auction" style={{ color: color13, fontSize: `${detailfont}px` }} ><div>Rajkumar college campus</div></div>
                            <div class="bidby" >
                                <div id="selteamlogo">
                                    <img src={teamdefaultLogo} />

                                </div>
                                <div id="selteamname" style={{ display: `${!showteam ? 'none' : 'flex'}`, color: color5, fontSize: `${teamfont}px` }}>CHENNAI SUPER KINGS</div>

                            </div>
                            <div class="teammax" style={{ display: `${!showmax ? 'none' : 'block'}` }} >
                                <div class="teammaxpl maxpn" style={{ border: `2px solid ${color19}`, background: `linear-gradient(90deg, ${color18} 0%, ${color19} 100%) content-box` }}>
                                    <div style={{ color: color14 }} class="lbl">MAX<br />BID</div>
                                    <div style={{ color: color15 }} id="selteammaxpoint" class="val">14100.0</div>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div class="teammaxpl getpl" style={{ border: `2px solid ${color19}`, background: `linear-gradient(90deg, ${color18} 0%, ${color19} 100%) content-box` }}>
                                    <div style={{ color: color14 }} class="lbl">PLAYERS</div>
                                    <div style={{ color: color15 }} id="selteamtotalplayer" class="val">9/13</div>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                            </div>
                            <div id="auctionpoint" style={{ color: color2, fontSize: `${bidfont}px` }}>180.0<span class="pointtyp"> lakh</span></div>

                            {/* <div class="soldviewx soldoutteam" style="display: none;">
                                        <div style="text-align: right;" id="selteamlogo">
                                            <img id="soldoutteamlogo" src="https://mscspa.s3.amazonaws.com/teams/1713606857_79524.png">
                                        </div>
                                        <div id="soldoutteamname"></div>
                                        <div class="soldteammax">
                                            <span style=" display:contents" class="lbl">MAX</span>
                                            <span id="selteammaxpoint" style=" display:contents"></span> &nbsp;
                                            <span style="" class="lbl">P</span>
                                            <span id="selteamtotalplayer" style=""></span>
                                        </div>
                                    </div> */}

                        </div>
                    }
                    {theme == 12 &&
                        <div class="pgchild theme12 pg_2 pg_a"
                            style={{
                                backgroundImage: `url(${themebg})`,
                                backgroundSize: 'cover', // Make sure background covers the entire div
                                backgroundPosition: 'center' // Center the background image
                            }}   >
                            <div id="stars"></div>
                            <div id="stars2"></div>
                            <div id="stars3"></div>
                            <div class="grouptbnamelist">
                            </div>
                            <div class="spnlogopos">
                                <img src="https://mscspa.s3.amazonaws.com/sponsor/29390240910172915109.jpg" id="spn_lg_1" class="spn_lg spn_lg_1" />

                            </div>

                            {/* <div class="hddiv1" >
                                <img src="/manage/images/background/spabgsold.jpg"/>
                            </div> */}

                            {/* <div id="hammercount" style="display: none;"></div> */}

                            {/* <div class="leaguename">
                                <div class="clubname">MY AUCTION<div><div class="clubname_season"> PLAYER AUCTION </div></div></div>    </div> */}
                            <div class="auctionlogo auctionstart">

                                <img src={aucmoredetail?.path + aucmoredetail?.detail.logo} />
                            </div>
                            <div class="plcode">429</div>

                            <div class="spalogo auctionstart">
                                <img src="https://superplayerauction.com/manage/images/background/superplwhite.png" />
                            </div>
                            <div class="alertmsg"></div>
                            <div class="playerdetail2" ></div>

                            <div class="playerdetail" >

                                {/* <div class="photobgmfcl"></div> */}
                                {/* <div class="phfram2">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME2.png?a" />
                                </div>
                                <div class="phfram1">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME1.png?a" />

                                </div> */}
                                <div class="iswkp"><span><img src="https://superplayerauction.com/manage/images/ball.png" /></span></div>
                                <div id="pic">
                                    <div class="polyout">
                                        <div class="polyin">
                                            <img src="https://mscspa.s3.amazonaws.com/playersphoto/1728977074_24638.png?c" />
                                        </div>
                                    </div>
                                </div>
                                <div class="playertext">
                                    <div id="playername">Bhupendra singh&nbsp;</div>
                                    <div id="playertyp">Bowler&nbsp;</div>

                                    <div id="playerage">Right Armed Player</div>
                                    <div style={{ clear: 'both' }}></div>
                                    <div class="baseamt"></div>
                                    <div class="isage"> 18 <span class="yrs">YRS</span></div>
                                    <div id="playername2"></div>
                                    <div id="playertyp2"></div>

                                    <div class="sidehr"> </div>
                                    <div class="sidehr2"> </div>
                                </div>

                            </div>
                            {/* <div style="position: absolute; " class="isrunwkt">

                            </div> */}
                            <div class="playerbase">

                                <div class="tp"></div>


                                <div class="val">25000</div>
                                <div class="btm"></div>
                                <div class="lbl">BASE VALUE</div>

                            </div>
                            <div class="extdetail" ><div>Amilidih</div></div>
                            <div class="bidby" >
                                <div id="selteamlogo">
                                    <img src={teamdefaultLogo} />

                                </div>
                                <div id="selteamname">CHENNAI SUPER KINGS</div>

                            </div>
                            <div class="teammax" >
                                <span class="lbl">MAX</span>
                                <span id="selteammaxpoint" >14100.0</span> &nbsp;
                                <span class="lbl">P</span>
                                <span id="selteamtotalplayer" >9/13</span>
                            </div>
                            <div id="auctionpoint" >180.0<span class="pointtyp"> lakh</span></div>
                            {/* <div id="auctionpoint" style="display: none;"></div> */}
                            {/* <div id="unsolddiv" style="display: none;">
                                        <img src="https://mscspa.s3.amazonaws.com/file/29390240803144350349.png" style="width: 100%">

                                    </div> */}
                            {/* <div style="color: yellow; display: none;" id="soldauctionpoint" class="soldview">
                                    </div> */}
                            {/* <div class="soldviewx soldoutteam" style="display: none;">
                                        <div style="text-align: right;" id="selteamlogo">
                                            <img id="soldoutteamlogo">
                                        </div>
                                        <div id="soldoutteamname"></div>
                                        <div class="soldteammax">
                                            <span style=" display:contents" class="lbl">MAX</span>
                                            <span id="selteammaxpoint" style=" display:contents"></span> &nbsp;
                                            <span style="" class="lbl">P</span>
                                            <span id="selteamtotalplayer" style=""></span>
                                        </div>
                                    </div> */}
                            {/* <div class="soldoutteamstamp soldstamphide" style="display: block;">
                
                                    <img src="/manage/images/soldstamp.png">
                            
                          </div>
                    <div id="tbnamelist" style="display: none;"></div> */}
                            {/* </div> */}
                        </div>
                    }

                    {theme == 18 &&
                        <div class="pgchild theme18 pg_2 pg_a"
                            style={{
                                backgroundImage: `url(${themebg})`,
                                backgroundSize: 'cover', // Make sure background covers the entire div
                                backgroundPosition: 'center' // Center the background image
                            }}
                        >

                            <div id="stars"></div>
                            <div id="stars2"></div>
                            <div id="stars3"></div>
                            <div class="grouptbnamelist">

                            </div>
                            <div class="spnlogopos">
                                <img src="https://mscspa.s3.amazonaws.com/sponsor/29390240910172915109.jpg" id="spn_lg_1" class="spn_lg spn_lg_1" />

                            </div>

                            {/* <div class="hddiv1" style="position: absolute; left:-5000px; width:500px">
                                <img src="https://superplayerauction.com/manage/images/background/spabgsold.jpg"/>
                            </div> */}

                            {/* <div id="hammercount" style="display: none;">18</div> */}

                            <div class="leaguename">
                                <div class="clubname auction" style={{ color: color }}>{aucmoredetail?.detail.auctionname}<div><div class="clubname_season" style={{ display: `${!showauctionhead ? 'none' : 'block'}` }}> <span style={{ background: isplbg ? `linear-gradient(45deg, ${color6} 0%, ${color6} 32%, ${color7} 55%, ${color7} 100%, ${color7} 100%)` : 'transparent', color: color20 }}>PLAYER</span>  AUCTION </div></div></div>    </div>
                            <div class="auctionlogo auctionstart">

                                <img src={aucmoredetail?.path + aucmoredetail?.detail.logo} />
                            </div>
                            {/*  <div class="plcode auction" >443</div>*/}

                            <div class="spalogo auctionstart">
                                <img src="https://superplayerauction.com/manage/images/background/superplwhite.png" />
                            </div>
                            <div class="alertmsg"></div>
                            <div class="playerdetail2 auction" ></div>

                            <div class="playerdetail auction" >

                                {/* <div class="photobgmfcl"></div>
                                <div class="phfram2">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME2.png?a" />
                                </div>
                                <div class="phfram1">
                                    <img src="https://superplayerauction.com/manage/images/PHOTOFRAME1.png?a" />

                                </div> */}
                                {/* <div class="iswkp" ><span><img src="https://superplayerauction.com/manage/images/bat.png" /></span><span><img src="https://superplayerauction.com/manage/images/ball.png" /></span></div> */}
                                <div class="isage"> 16 <span class="yrs">YRS</span></div>
                                <div id="pic" style={{ background: `linear-gradient(to right, ${color16}, ${color17}, ${color16})` }}>
                                    <div class="polyout">
                                        <div class="polyin">
                                            <img src="https://mscspa.s3.amazonaws.com/playersphoto/1728977074_24638.png?c" />
                                        </div>
                                    </div>
                                </div>
                                <div class="playertext">
                                    <div id="playername" style={{ color: color3, fontSize: `${maindetailfont}px`, background: `linear-gradient(to right, ${color10}, ${color11}, ${color10})` }}>Bhupendra singh&nbsp;</div>
                                    <div id="playertyp" style={{ color: color3, fontSize: `${maindetailfont}px`, background: `linear-gradient(to right, ${color10}, ${color11}, ${color10})` }}>Batsman, Bowler&nbsp;</div>

                                    {/* <div id="playerage">Right Armed Player</div> */}
                                    <div style={{ clear: 'both' }}></div>
                                    <div class="baseamt"></div>
                                </div>

                            </div>
                            {/* <div style="position: absolute; " class="isrunwkt">

                                    </div> */}
                            {/* <div style="position: absolute; display: none; " class="playerbase">

                                        <div class="tp"></div>


                                        <div class="val">25000</div>
                                        <div class="btm"></div>
                                        <div class="lbl">BASE VALUE</div>

                                    </div> */}
                            <div class="extdetail auction" style={{ color: color13, fontSize: `${detailfont}px` }} ><div>New India Titans</div></div>
                            <div class="bidby" >
                                <div id="selteamlogo">
                                    <img src={teamdefaultLogo} />

                                </div>
                                <div id="selteamname" style={{ display: `${!showteam ? 'none' : 'flex'}`, color: color5, fontSize: `${teamfont}px` }}>CHENNAI SUPER KINGS</div>

                            </div>
                            <div class="teammax" style={{ display: `${!showmax ? 'none' : 'block'}` }}>
                                <div class="teammaxpl maxpn" style={{ border: `2px solid ${color19}`, background: `linear-gradient(90deg, ${color18} 0%, ${color19} 100%) content-box` }}>
                                    <div style={{ color: color14 }} class="lbl">MAX<br />BID</div>
                                    <div style={{ color: color15 }} id="selteammaxpoint" class="val">308.5</div>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div class="teammaxpl getpl" style={{ border: `2px solid ${color19}`, background: `linear-gradient(90deg, ${color18} 0%, ${color19} 100%) content-box` }}>
                                    <div style={{ color: color14 }} class="lbl">PLAYERS</div>
                                    <div style={{ color: color15 }} id="selteamtotalplayer" class="val">2/18</div>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                            </div>
                            <div id="auctionpoint" style={{ color: color2, fontSize: `${bidfont}px` }} >180.0<span class="pointtyp"> lakh</span></div>
                            {/* <div id="unsolddiv" style="display: none;">
                                        <img src="https://mscspa.s3.amazonaws.com/file/29390240803144350349.png" style="width: 100%">

                                    </div>
                                    <div style="color: yellow; display: none;" id="soldauctionpoint" class="soldview">
                                    </div> */}
                            {/* <div class="soldviewx soldoutteam" style="display: none;">
                                        <div style="text-align: right;" id="selteamlogo">
                                            <img id="soldoutteamlogo" src="https://mscspa.s3.amazonaws.com/teams/1713606857_79524.png">
                                        </div>
                                        <div id="soldoutteamname"></div>
                                        <div class="soldteammax">
                                            <span style=" display:contents" class="lbl">MAX</span>
                                            <span id="selteammaxpoint" style=" display:contents"></span> &nbsp;
                                            <span style="" class="lbl">P</span>
                                            <span id="selteamtotalplayer" style=""></span>
                                        </div>
                                    </div>
                                    <div class="soldoutteamstamp soldstamphide" style="display: block;">

                                        <img src="/manage/images/soldstamp.png">

                                    </div>
                                    <div id="tbnamelist" style="display: none;"></div> */}
                        </div>
                    }

                </div>
            </div>
            {/* <div onClick={downloadcustomchanges} className='cutom_design_bottom'><button>Download changes</button></div>
            <div onClick={themesubmit} className='cutom_design_bottom'><button>Apply Theme</button></div> */}
            <div className="action-buttons">
                
                <button
                    className="download-btn"
                    onClick={downloadcustomchanges}
                >
                    Download Theme
                </button>
                <button
                    className="apply-btn"
                    onClick={themesubmit}
                >
                    Apply Changes
                </button>
            </div>
        </div>
    )
}
